import { categories } from '@/mocks/categories';

const trendingCategories = [
  { ...categories[6] },
  { ...categories[7] },
  { ...categories[8] },
  { ...categories[9] },
  { ...categories[10] },
  { ...categories[11] },
];

const trendingImages = [
  'https://readdy.ai/api/search-image?query=Elegant%20coordinated%20two-piece%20outfit%20set%20laid%20flat%20on%20light%20oyster%20linen%20background%2C%20soft%20diffused%20daylight%2C%20high-end%20minimal%20fashion%20flatlay%2C%20refined%20fabric%20texture%2C%20sophisticated%20monochrome%20styling%2C%20boutique%20editorial%20quality&width=600&height=600&seq=trend-sets-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20underwear%20neatly%20arranged%20on%20warm%20sand%20textured%20surface%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20product%20photography%2C%20subtle%20fabric%20weave%20detail%2C%20refined%20intimate%20apparel%20presentation%2C%20gentle%20aesthetic&width=600&height=600&seq=trend-underwear-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20flat%20on%20light%20beige%20studio%20background%2C%20dynamic%20athletic%20wear%20photography%2C%20soft%20studio%20lighting%2C%20clean%20sporty%20composition%2C%20premium%20mesh%20fabric%20texture%20visible%2C%20modern%20athletic%20aesthetic&width=600&height=600&seq=trend-jersey-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20accessories%20including%20sunglasses%20watch%20and%20bracelet%20on%20warm%20ivory%20marble%20surface%2C%20soft%20natural%20light%2C%20elegant%20editorial%20still%20life%20photography%2C%20refined%20luxury%20composition%2C%20sophisticated%20accessories%20aesthetic&width=600&height=600&seq=trend-accessories-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Stylish%20leather%20tote%20bag%20and%20crossbody%20purse%20arranged%20on%20light%20cream%20surface%2C%20soft%20window%20light%2C%20clean%20minimal%20fashion%20accessories%20photography%2C%20premium%20leather%20grain%20texture%2C%20sophisticated%20everyday%20luxury%20aesthetic&width=600&height=600&seq=trend-bags-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Elegant%20leather%20belts%20with%20brass%20buckles%20arranged%20artfully%20on%20warm%20oatmeal%20linen%2C%20soft%20directional%20lighting%2C%20refined%20accessories%20flatlay%20photography%2C%20subtle%20texture%20detail%2C%20classic%20sophisticated%20composition&width=600&height=600&seq=trend-belts-v2&orientation=squarish',
];

export default function ProductScroll() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-foreground-900">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-16">
          <div>
            <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-foreground-600 text-background-50 text-xs font-medium whitespace-nowrap">
              Catalogo 2026
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mt-4 md:mt-0 max-w-lg">
            Itaobuy Sheet Trends
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trendingCategories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:translate-y-[-4px] transition-transform duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={trendingImages[index]}
                  alt={cat.name}
                  title={`${cat.name} - Itaobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 bg-foreground-900">
                <h3 className="text-lg font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-foreground-400 text-xs">
                  Esplora la collezione
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}